import React from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Flex } from '@knockrentals/knock-shared-web-v2';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  buttonActions: {
    justifyContent: 'space-between',
  },
});

export const FeatureDrawerActions = ({
  closeDrawer,
  isPrimaryButtonDisabled,
  primaryButtonText,
  primaryButtonAction,
  secondaryButtonAction,
  secondaryButtonText,
  tertiaryButtonAction,
  tertiaryButtonText,
}) => {
  const classes = useStyles();

  return (
    <Drawer.Footer className={classes.buttonActions}>
      <div>
        {tertiaryButtonAction && (
          <Button onClick={tertiaryButtonAction}>{tertiaryButtonText}</Button>
        )}
      </div>

      <Flex gap={16}>
        <Button onClick={secondaryButtonAction || closeDrawer} variant="text">
          {secondaryButtonText}
        </Button>
        <Button
          disabled={isPrimaryButtonDisabled}
          onClick={primaryButtonAction}
        >
          {primaryButtonText}
        </Button>
      </Flex>
    </Drawer.Footer>
  );
};

FeatureDrawerActions.propTypes = {
  closeDrawer: PropTypes.func,
  isPrimaryButtonDisabled: PropTypes.bool,
  primaryButtonAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  tertiaryButtonAction: PropTypes.func,
  tertiaryButtonText: PropTypes.string,
};
